var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input",
    _vm._b(
      {
        attrs: {
          size: "medium",
          placeholder: "自动生成随机编号",
          disabled: "",
          readonly: "",
        },
        model: {
          value: _vm.changeValue,
          callback: function ($$v) {
            _vm.changeValue = $$v
          },
          expression: "changeValue",
        },
      },
      "el-input",
      Object.assign({}, _vm.item),
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }